import React, {useEffect, useState} from "react";
import {
    List,
    ListItem,
    ListItemPrefix,
    Accordion,
    AccordionHeader,
    AccordionBody,
} from "@material-tailwind/react";
import {useNavigate} from "react-router";
import {Link} from "react-router-dom";
import {Menu} from "../routing/menu";
import {showToast} from "../general/CustomToast";
import CustomIcon from "../general/CustomIcon";
import {CustomTypography} from "../general/CustomTypography";
import {KeyboardArrowDown} from "@mui/icons-material";

interface Props {
    toggleIsNavOpen?: any;
}

export default function LeftSideBar({toggleIsNavOpen}: Props) {
    const actualUrl = window.location.href
    const history = useNavigate();
    const [open, setOpen] = useState(0);
    const [subMenu, setSubMenu] = useState('');

    // useEffect(() => {
    //     if (successListMenus) {
    //         successListMenus.forEach((menu) => {
    //             menu.submenu?.forEach((subMenuItem) => {
    //                 if (actualUrl.includes(subMenuItem.route!)) {
    //                     setSubMenu(subMenuItem.description!)
    //                     setOpen(menu.idMenu!)
    //                 }
    //             })
    //         })
    //     }
    // }, [successListMenus, actualUrl]);

    const handleOpen = (value: any) => {
        setOpen(open === value ? undefined : value);
    };

    const getIcon = (menu: string, index: number) => {
        return (
            <CustomIcon iconName={menu} className={`h-5 w-5 ${open === index ? 'text-white' : ''}`}/>
        )
    }

    return (
        <>
            {/*{!loadingListMenus && successListMenus && successListMenus.length > 0 &&*/}
            {/*    <List placeholder='list'*/}
            {/*          className="h-screen p-0 sm:fixed bg-menuColor gap-0 min-w-full max-w-full sm:min-w-[219px] sm:max-w-[219px] rounded-none border-r-lineColor border-r-[1px] border-b-transparent">*/}
            {/*        {!loadingListMenus && successListMenus && successListMenus.map((menu) => {*/}
            {/*            if (menu.idMenu !== undefined && menu.idMenu !== null) {*/}
            {/*                return (*/}
            {/*                    <Accordion*/}
            {/*                        open={open === menu.idMenu!} placeholder='accordion'*/}
            {/*                        icon={*/}
            {/*                            <div className={`flex max-w-[10px] max-h-[10px] p-0 transition-transform ${open === menu.idMenu! ? "rotate-180" : ""}`}>*/}
            {/*                                <KeyboardArrowDown*/}
            {/*                                    className={`ml-[-7px] mt-[-7px] ${open === menu.idMenu! ? 'text-white' : 'text-empColorPrimary'}`}/>*/}
            {/*                            </div>*/}
            {/*                        }*/}
            {/*                    >*/}
            {/*                        <ListItem key={menu.idMenu} placeholder={'list-item'}*/}
            {/*                                  className={`p-0 rounded-none ${open === menu.idMenu! ? 'bg-empColorPrimary hover:bg-gray-600-600' : 'bg-menuItemColor hover:bg-gris'} border-b-lineColor border-b-[1px]`}*/}
            {/*                                  selected={open === menu.idMenu!}>*/}
            {/*                            <AccordionHeader onClick={() => handleOpen(menu.idMenu!)}*/}
            {/*                                             className="border-b-0 py-[22px] px-[11px]"*/}
            {/*                                             placeholder='accordion-header'>*/}
            {/*                                <ListItemPrefix className="mr-[9px]" placeholder='list-menu'>*/}
            {/*                                    {getIcon(menu?.icon ? menu.icon : '', menu.idMenu!)}*/}
            {/*                                </ListItemPrefix>*/}
            {/*                                <CustomTypography color={open === menu.idMenu! ? 'white' : 'blue-gray'}*/}
            {/*                                                  className="mr-auto font-normal text-[12px]"*/}
            {/*                                                  text={menu.description}/>*/}
            {/*                            </AccordionHeader>*/}
            {/*                        </ListItem>*/}
            {/*                        <AccordionBody className="py-0">*/}
            {/*                            <List placeholder='list' className="p-0 gap-0 text-[14px]">*/}
            {/*                                {menu.submenu?.map((itemSubMenu, indexSubMenu) => {*/}
            {/*                                    const active = subMenu === itemSubMenu.description;*/}
            {/*                                    const classname = `pl-[18px] rounded-none h-[47px] focus:text-primary ${active ? 'text-empColorPrimary' : ''} ${(indexSubMenu + 1) === menu.submenu?.length ? '' : 'border-b-empColorSecondary'} border-b-[0.5px]`;*/}

            {/*                                    return (*/}
            {/*                                        <ListItem key={indexSubMenu} placeholder='list-item'*/}
            {/*                                                  className={classname}*/}
            {/*                                                  onClick={() => {*/}
            {/*                                                      setSubMenu(itemSubMenu.description!)*/}
            {/*                                                      history(`/${itemSubMenu.route!}`)*/}
            {/*                                                      if (toggleIsNavOpen) toggleIsNavOpen()*/}
            {/*                                                  }}>*/}
            {/*                                            <Link to={`/${itemSubMenu.route!}`}>*/}
            {/*                                                {itemSubMenu.description!}*/}
            {/*                                            </Link>*/}
            {/*                                        </ListItem>*/}
            {/*                                    );*/}
            {/*                                })}*/}
            {/*                                {null} /!* Agregar esta línea para solucionar el warning *!/*/}
            {/*                            </List>*/}
            {/*                        </AccordionBody>*/}
            {/*                    </Accordion>*/}
            {/*                );*/}
            {/*            }*/}
            {/*            return null; // Agregar este return para solucionar el warning*/}
            {/*        })}*/}

            {/*    </List>*/}
            {/*}*/}
        </>
    );
}
